module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticStyle: {
      "height": "100vh"
    },
    style: ({
      'background': _vm.row.show_bg
    })
  }, [_c('div', {
    staticClass: "machine-head",
    style: ({
      'color': _vm.row.show_font_color
    })
  }, [_c('img', {
    staticStyle: {
      "width": "80px",
      "top": "10px",
      "left": "10px",
      "position": "fixed"
    },
    attrs: {
      "src": "https://ccago.oss-cn-hangzhou.aliyuncs.com/uploader/000/user-xxx/vc-upload-1775121359591-20.png"
    }
  }), _vm._v(" "), _c('div', [_vm._v(_vm._s(_vm.saiqu.name))]), _vm._v(" "), _c('div', [_vm._v(_vm._s(_vm.row.title))]), _vm._v(" "), _c('img', {
    staticStyle: {
      "width": "80px",
      "position": "fixed",
      "top": "10px",
      "right": "10px"
    },
    attrs: {
      "src": "https://wa.ccachina.net/img/logo.58b57af4.png"
    }
  })]), _vm._v(" "), (_vm.row.show_jianlu_time > 0) ? _c('van-swipe', {
    staticClass: "header-swiper",
    attrs: {
      "autoplay": _vm.row.show_jianlu_time,
      "indicator-color": "FD2840"
    }
  }, _vm._l((_vm.list), function(sublist, key) {
    return _c('van-swipe-item', {
      key: key
    }, [_c('table', {
      staticClass: "machine-table",
      style: ('height:' + (_vm.clientHeight - 104 - 50 - 20) + 'px; overflow-y: auto;')
    }, [_c('thead', {
      style: ({
        'background': _vm.row.show_bg_2,
        'color': _vm.row.show_font_color_2
      })
    }, [_c('tr', [_c('th', [_vm._v("出场顺序")]), _vm._v(" "), _c('th', [_vm._v("项目名称")]), _vm._v(" "), _c('th', [_vm._v("队伍名称")]), _vm._v(" "), _c('th', [_vm._v("检录时间1")]), _vm._v(" "), _c('th', [_vm._v("检录时间2")]), _vm._v(" "), _c('th', [_vm._v("预估检录1")]), _vm._v(" "), _c('th', [_vm._v("状态")])])]), _vm._v(" "), _c('tbody', {
      style: ('height:' + (_vm.clientHeight - 104 - 50 - 20) + 'px; overflow-y: scroll;')
    }, _vm._l((sublist), function(item, index) {
      return _c('tr', {
        key: index,
        style: ({
          'color': _vm.row.show_font_color_2,
          'background': index % 2 == 0 ? _vm.row.show_bg : _vm.row.show_bg_2
        })
      }, [_c('td', [_vm._v(_vm._s(item.index))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.subject_name))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.mingcheng))]), _vm._v(" "), _c('td', {
        staticClass: "jianlu-check-time-cell"
      }, [_vm._v(_vm._s(_vm.formatCheckTimeHm(item.check_time)))]), _vm._v(" "), _c('td', {
        staticClass: "jianlu-check-time-cell"
      }, [_vm._v(_vm._s(_vm.formatCheckTimeHm(item.check_time2)))]), _vm._v(" "), _c('td', {
        staticClass: "jianlu-check-time-cell jianlu-est-check-time-cell",
        class: {
          'jianlu-est-check-time-cell--active': _vm.delayMinutes !== 0
        }
      }, [_vm._v(_vm._s(_vm.formatEstimatedCheckTime1(item.check_time)))]), _vm._v(" "), _c('td', {
        staticClass: "jianlu-status-cell"
      }, [(item.jianlu_status == 0) ? _c('span', {
        staticClass: "jsl-st jsl-st--pending"
      }, [_vm._v("待检录")]) : (item.jianlu_status == 1) ? _c('span', {
        staticClass: "jsl-st jsl-st--stage"
      }, [_vm._v("检录1")]) : (item.jianlu_status == 2) ? _c('span', {
        staticClass: "jsl-st jsl-st--stage"
      }, [_vm._v("检录2")]) : (item.jianlu_status == 4) ? _c('span', {
        staticClass: "jsl-st jsl-st--signed"
      }, [_vm._v("已签到")]) : (item.jianlu_status == 5) ? _c('span', {
        staticClass: "jsl-st jsl-st--done-check"
      }, [_vm._v("检录完成")]) : (item.jianlu_status == 6) ? _c('span', {
        staticClass: "jianlu-status-zhenggai"
      }, [_c('span', {
        staticClass: "jsl-st jsl-st--rectify"
      }, [_vm._v("待整改")]), _vm._v(" "), (item.jianlu_note) ? _c('span', {
        staticClass: "jianlu-note-machine jsl-st-note"
      }, [_vm._v(_vm._s(item.jianlu_note))]) : _vm._e()]) : (item.jianlu_status == 7) ? _c('span', {
        staticClass: "jsl-st jsl-st--match-done"
      }, [_vm._v("比赛完成")]) : (item.jianlu_status == 8) ? _c('span', {
        staticClass: "jsl-st jsl-st--forfeit"
      }, [_vm._v("弃权")]) : (item.jianlu_status == 9) ? _c('span', {
        staticClass: "jsl-st jsl-st--timeout"
      }, [_vm._v("超时未到")]) : _vm._e(), _vm._v(" "), (item.jianlu_note) ? _c('div', {
        staticClass: "jianlu-note-machine jsl-st-note jianlu-note-below-status"
      }, [_vm._v(_vm._s(item.jianlu_note))]) : _vm._e()])])
    }), 0)])])
  }), 1) : _vm._e(), _vm._v(" "), _c('audio', {
    ref: "entranceAudio",
    staticStyle: {
      "position": "absolute",
      "width": "0",
      "height": "0",
      "opacity": "0",
      "pointer-events": "none"
    },
    attrs: {
      "preload": "none"
    },
    on: {
      "ended": _vm.onEntranceAudioEnded,
      "error": _vm.onEntranceAudioError
    }
  }), _vm._v(" "), _c('van-dialog', {
    attrs: {
      "width": "70vw",
      "class-name": "jianlu-broadcast-machine-dialog",
      "show-confirm-button": false,
      "close-on-click-overlay": false
    },
    model: {
      value: (_vm.broadcastDialogShow),
      callback: function($$v) {
        _vm.broadcastDialogShow = $$v
      },
      expression: "broadcastDialogShow"
    }
  }, [(_vm.broadcastPanel) ? _c('div', {
    staticClass: "jianlu-broadcast-dialog-shell",
    style: (_vm.broadcastDialogShellStyle)
  }, [_c('div', {
    staticClass: "jianlu-broadcast-titlebar",
    style: (_vm.broadcastDialogTitleStyle)
  }, [_vm._v("\n          请以下队伍入场\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "jianlu-broadcast-dialog-body",
    style: (_vm.broadcastDialogBodyStyle)
  }, [_c('p', [_c('span', {
    staticClass: "jianlu-broadcast-k",
    style: (_vm.broadcastDialogLabelStyle)
  }, [_vm._v("次序")]), _vm._v(" "), _c('span', {
    staticClass: "jianlu-broadcast-v"
  }, [_vm._v(_vm._s(_vm.broadcastPanel.index !== "" && _vm.broadcastPanel.index != null ? _vm.broadcastPanel.index : "—"))])]), _vm._v(" "), _c('p', [_c('span', {
    staticClass: "jianlu-broadcast-k",
    style: (_vm.broadcastDialogLabelStyle)
  }, [_vm._v("项目名称")]), _vm._v(" "), _c('span', {
    staticClass: "jianlu-broadcast-v"
  }, [_vm._v(_vm._s(_vm.broadcastPanel.subject_name || "—"))])]), _vm._v(" "), _c('p', [_c('span', {
    staticClass: "jianlu-broadcast-k",
    style: (_vm.broadcastDialogLabelStyle)
  }, [_vm._v("队伍名称")]), _vm._v(" "), _c('span', {
    staticClass: "jianlu-broadcast-v"
  }, [_vm._v(_vm._s(_vm.broadcastPanel.mingcheng || "—"))])]), _vm._v(" "), _c('p', {
    staticClass: "jianlu-broadcast-tip",
    style: (_vm.broadcastDialogTipStyle)
  }, [_vm._v("\n            " + _vm._s(_vm.broadcastPlaybackEnded ? "播报已结束" : "正在语音播报…") + "\n          ")])])]) : _vm._e()])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-5923489c","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/score/ScoreJianluList.vue
// module id = 2418
// module chunks = 0